<div class="layout-wrapper">
  <!-- Top Navigation Bar -->
  <nav class="navbar navbar-expand-lg navbar-dark bg-primary fixed-top">
    <div class="container-fluid">
      <button class="btn btn-link text-white me-3" (click)="toggleSidebar()" type="button">
        <i class="fas fa-bars"></i>
      </button>

      <a class="navbar-brand fw-bold" href="#" (click)="navigateTo('/dashboard')">
        <img src="assets/branding/flit-core-horizontal.svg" alt="Flit Core" class="logo-img me-2">
      </a>

      <div class="navbar-nav ms-auto d-flex align-items-center">
        <!-- Botão de Notificações -->
        <div class="d-flex align-items-center me-3 notification-wrapper">
          <button class="btn btn-link text-white p-2 navbar-action-btn position-relative" 
                  type="button" 
                  title="Notificações"
                  (click)="toggleNotifications()">
            <i class="fas fa-bell"></i>
            <span *ngIf="unreadNotificationsCount > 0" class="notification-badge">
              {{ unreadNotificationsCount }}
            </span>
          </button>

          <!-- Modal Dropdown de Notificações -->
          <div class="notifications-dropdown" [class.show]="showNotifications">
            <div class="notifications-header">
              <h5 class="notifications-title">Notificações</h5>
              <button class="btn btn-link mark-all-read" 
                      (click)="markAllAsRead()"
                      *ngIf="notifications.length > 0">
                Marcar todas como lidas
              </button>
            </div>

            <div class="notifications-body">
              <div *ngIf="notifications.length === 0" class="no-notifications">
                <i class="fas fa-bell-slash"></i>
                <p>Nenhuma notificação</p>
              </div>

              <div *ngFor="let notification of notifications" 
                   class="notification-item" 
                   [class.unread]="!notification.read">
                <div class="notification-avatar">
                  <div class="avatar-circle">
                    {{ notification.description.charAt(0).toUpperCase() }}
                  </div>
                </div>
                <div class="notification-content">
                  <p class="notification-message">{{ notification.description }}</p>
                  <small class="notification-date" *ngIf="notification.createdAt">
                    {{ notification.createdAt | date:'dd/MM/yyyy HH:mm' }}
                  </small>
                </div>
                <div class="notification-actions">
                  <button class="btn-icon" 
                          *ngIf="!notification.read"
                          (click)="toggleReadStatus(notification)"
                          title="Marcar como lida">
                    <i class="fas fa-envelope-open"></i>
                  </button>
                  <button class="btn-icon btn-delete" 
                          (click)="deleteNotification(notification.id)"
                          title="Excluir">
                    <i class="fas fa-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Avatar e nome do usuário -->
        <div class="d-flex align-items-center user-info" style="cursor: pointer;" (click)="navigateToProfile()">
          <div class="user-avatar me-2">
            <img *ngIf="userAvatar" [src]="userAvatar" alt="Avatar" class="avatar-img">
            <i *ngIf="!userAvatar" class="fas fa-user-circle"></i>
          </div>
          <span class="text-white user-name">{{ currentUserName }}</span>
        </div>
      </div>
    </div>
  </nav>

  <!-- Sidebar -->
  <div class="sidebar" [class.active]="sidebarOpen" style="background-color:#0B1220">
    <div class="sidebar-content" #sidebarContent>
      <div style="padding: 30px 20px;">
       <label style="font-size: 1.2rem; font-weight: 600; color: white; font-family: 'Poppins', sans-serif;">Menu</label>
      </div>
      <ul class="sidebar-menu">
        <li *ngFor="let item of filteredMenuItems; let i = index" class="menu-item-container">
          <!-- Menu item principal -->
          <a class="menu-item" 
             [class.active]="isMenuItemActive(item)"
             (click)="onMainMenuClick(item, i, $event)"
             style="text-decoration: none;">
            <i class="{{item.icon}} menu-icon"></i>
            <span class="menu-label">{{item.name}}</span>
            <i *ngIf="item.children && item.children.length > 0"
               class="fas fa-chevron-down submenu-arrow"
               [class.rotated]="activeSubmenuIndex === i"
               (click)="toggleSubmenu(i); $event.stopPropagation(); $event.preventDefault()"
               style="cursor: pointer;"></i>
          </a>
          
          <!-- Dropdown submenu -->
          <ul *ngIf="item.children && item.children.length > 0"
              #dropdownSubmenu
              class="dropdown-submenu"
              [class.show]="activeSubmenuIndex === i"
              [style.max-height]="activeSubmenuIndex === i ? 'none' : '0px'">
            <li *ngFor="let child of item.children; let j = index" class="submenu-entry">
              <!-- Se o child tem filhos, criar um submenu aninhado -->
              <ng-container *ngIf="child.children && child.children.length > 0">
                <div class="dropdown-item submenu-parent" [class.active]="isSubmenuItemActive(item, child)">
                  <span class="submenu-text submenu-link" 
                        (click)="toggleNestedSubmenu(i, j); $event.stopPropagation()"
                        style="cursor: pointer; flex: 1;">{{child.name}}</span>
                  <i class="fas fa-chevron-down nested-arrow" 
                     [class.rotated]="isNestedSubmenuOpen(i, j)"
                     (click)="toggleNestedSubmenu(i, j); $event.stopPropagation()"
                     style="cursor: pointer;"></i>
                </div>
                <!-- Submenu aninhado -->
                <ul class="nested-submenu"
                    #nestedSubmenu
                    [class.show]="isNestedSubmenuOpen(i, j)"
                    [style.max-height]="isNestedSubmenuOpen(i, j) ? 'none' : '0px'">
                  <li *ngFor="let nestedChild of child.children">
                    <a class="nested-dropdown-item nested-submenu-item" 
                       [class.active]="isNestedSubmenuItemActive(item, child, nestedChild)"
                       (click)="navigateTo(nestedChild.route)">
                      <span class="nested-submenu-link">{{nestedChild.name}}</span>
                    </a>
                  </li>
                </ul>
              </ng-container>
              <!-- Se não tem filhos, item normal -->
              <a *ngIf="!child.children || child.children.length === 0" 
                 class="dropdown-item submenu-item" 
                 [class.active]="isSubmenuItemActive(item, child)"
                 (click)="navigateTo(child.route, child.queryParams)">
                <span class="submenu-link">{{child.name}}</span>
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    
    <!-- Botão de Scroll para o Final -->
    <div class="scroll-to-bottom-btn" 
         *ngIf="showScrollToBottomButton && sidebarOpen" 
         (click)="scrollToBottom()"
         title="Ir para o último item">
      <i class="fas fa-chevron-down"></i>
    </div>
    
    <!-- Footer do Sidebar -->
    <div class="sidebar-footer">
      <div class="sidebar-footer-item">
        <i class="fas fa-code-branch"></i>
        <span>Versão 1.0.0</span>
      </div>
    </div>
  </div>



  <!-- Main Content -->
  <div class="main-content" [class.sidebar-open]="sidebarOpen">
    <div class="content-wrapper">
      <ng-content></ng-content>
    </div>
  </div>

  <!-- Sidebar Overlay for Mobile -->
  <div class="sidebar-overlay" [class.active]="sidebarOpen" (click)="closeSidebar()"></div>
</div>